"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _withLogger = _interopRequireDefault(require("./withLogger"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ErrorBoundary);
    _this = _callSuper(this, ErrorBoundary, [props]);
    _this.state = {
      error: null,
      correlationId: null
    };
    return _this;
  }
  (0, _inherits2["default"])(ErrorBoundary, _React$Component);
  return (0, _createClass2["default"])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      var _this$props = this.props,
        logger = _this$props.logger,
        componentName = _this$props.componentName;
      var correlationId = (0, _uuid.v4)();
      this.setState({
        error: error,
        correlationId: correlationId
      });
      logger.error(error.message, {
        componentName: componentName,
        correlationId: correlationId
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        showError = _this$props2.showError,
        errorComp = _this$props2.errorComp;
      if (this.state.error && typeof showError === 'function' && showError() && typeof errorComp === 'function') {
        return errorComp(this.state.correlationId);
      }
      return children;
    }
  }]);
}(_react["default"].Component);
ErrorBoundary.propTypes = {
  children: _propTypes["default"].any,
  componentName: _propTypes["default"].string,
  showError: _propTypes["default"].func,
  errorComp: _propTypes["default"].func
};
var ErrorBoundaryWithLogger = (0, _withLogger["default"])(ErrorBoundary);
var _default = exports["default"] = function _default(Component) {
  var name = Component.displayName || Component.name;
  var Wrapped = function Wrapped(props) {
    /* eslint-disable react/prop-types */
    var showError = props.showError,
      errorComp = props.errorComp;
    return /*#__PURE__*/_react["default"].createElement(ErrorBoundaryWithLogger, {
      componentName: name,
      showError: showError,
      errorComp: errorComp
    }, /*#__PURE__*/_react["default"].createElement(Component, props));
  };
  (0, _hoistNonReactStatics["default"])(Wrapped, Component);
  Wrapped.propTypes = {
    errorComp: _propTypes["default"].func,
    showError: _propTypes["default"].func
  };
  Wrapped.defaultProps = {
    showError: function showError() {
      return true;
    }
  };
  Wrapped.displayName = name ? "withErrorBoundary(".concat(name, ")") : 'withErrorBoundary';
  return Wrapped;
};